<template>
    <div class="orderList">
        <!-- 头部 -->
        <div class="orderHeader">
            <div class="header-left" @click="back">
            <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
            <p>服务订单</p>
            </div>
            <div class="header-right" @click="toHome">
            <span class="iconfont iconshouye"></span>
            </div>
        </div>
       <!-- 标签页 -->
       <div class="tabs" ref="tabs">
         <van-tabs @click="changeTabs" animated color="green" sticky :offsetTop=40>
             <van-tab v-for="(item,index) in tabArr" :title="item" :key="index">
                <div class="orderOut" v-for="(item,index) in dataArr" :key="index">
                    <p class="orderTime">下单时间：{{item.CreateDate}}</p>
                    <div class="orderInner">
                        <div class="innerHeader">
                            <span class='order-status-tips'>{{item.Status}}</span>
                            <div class="headerText">《{{index+1}}》 单号：{{item.BillCode}}</div>
                        </div>
                        <div class="innerContent" v-if='item.ServiceName=="定期保洁" || item.ServiceName=="钟点保洁"' @click='toOrderDetail(item.OrderId)'>
                             <p>预约服务项目：{{item.ServiceName}}</p>
                             <p>服务地点：{{item.CustomerAddress}}</p>
                             <p>联系人：{{item.CustomerName}} {{item.CustomerPhone}}</p>
                             <p v-if='!!item.StartTime && item.OrderType!="合作公司"'>预约上门时间：{{item.StartTime}}</p>
							 <p v-if='item.Remarks'>备注：{{item.Remarks}}</p>
                             <span class='info-tips'>基本信息</span>
                        </div>
                        <div class="innerContent" v-else>
							<p v-if='item.ListOrderOffer.length==0'>预约服务项目：{{item.ServiceName}}</p>
							<p>服务地点：{{item.CustomerAddress}}</p>
							<p>联系人：{{ item.CustomerName }} {{ item.CustomerPhone}}</p>
							<p v-if='!!item.StartTime && item.OrderType!="合作公司"'>预约上门时间：{{item.StartTime}}</p>
							<p v-if='item.Remarks'>备注：{{item.Remarks}}</p>
							<p v-if='item.IsApplyCancel==1' style="color:red">申请取消中</p>
							<span class='info-tips'>基本信息</span>
						</div>
                        <div class="order-price" v-if="item.NegIsAgree == 1 ">
							<p>洽谈人：{{item.NegUserName}}
								<a :href="'tel:' + item.NegUserPhone">{{item.NegUserPhone}}</a>
							</p>
							<p>服务总费用：{{item.Amount}}元</p>
							<span class='info-tips'>报价信息</span>
							<span class='info-price-btn' v-if='item.IsOffer==1 && item.IsConfirmOffer==1' @click="toOfferWork(item.OrderId)">查看报价单</span>
						</div>
                        <div class="order-process-info" v-if="item.ListOrderOffer.length!=0" v-for='k in item.ListOrderOffer'>
							<p>服务项目：{{k.ServiceName}}</p>
							<p>金额：{{k.Amount}}</p>
							<p>组长：{{k.EmployeeName}}
								<a :href="'tel:' + k.EmployeePhone">{{k.EmployeePhone}}</a>
							</p>
							<p>施工时间：{{k.WorkTime}}</p>
							<p>施工进度：{{k.IsFinish}}
								<span v-if='k.CustomerResult=="合格"'> （已验收）</span>
							</p>
							<span class='info-tips'>施工信息</span>
							<span class='info-assess-btn' style="padding: 10px;" v-if='k.IsFinish=="已完工" && k.CustomerResult!="合格"' @click="toOfferResult(k.OfferId)">确认验收</span>
						</div>
                        <div class="innerButton" v-if='item.Status=="待预约" && item.OrderType == "家政套餐" && item.PaymentAmount == 0'>
                            <div class="order-cancal-btn" v-if='item.IsApplyCancel!=1'   style='width:100%' @click="toCancel(item.OrderId)">
									取消订单
							</div>
                        </div>
                        <div class="innerButton" v-if='item.Status=="待预约" && item.OrderType == "家政套餐" && item.PaymentAmount > 0' style="display:none">
								
						</div>
                        <div class="innerButton" v-if='item.Status=="待预约" && item.OrderType!=="家政套餐"'>
							<div class="order-cancal-btn" v-if='item.IsApplyCancel!=1 ' :style='item.OrderType=="合作公司"?"width:100%":""' @click="toCancel(item.OrderId)">
								取消订单
							</div>
							<div class="order-baseinfo-modify-btn" v-if='item.OrderType!="合作公司"' @click='toEditOrder(item.OrderId,item.ServiceName)'>
								修改订单
							</div>
						</div>
                        <div class="innerButton" v-if='item.Status=="待服务" && item.OrderType!=="家政套餐"'>
							<div class="order-cancal-btn" v-if='item.IsApplyCancel!=1' @click="toCancel(item.OrderId)">
								取消订单
							</div>
							<div class="order-baseinfo-modify-btn" v-if='item.IsOffer==1 && item.IsConfirmOffer!=1' @click="toOfferWork(item.OrderId)"> 查看并确认报价单 </div>
							<div class="order-baseinfo-modify-btn" v-else @click="toWxPay(item.OrderId)"> 付款 </div>
						</div>
                        <div class="order-pay-btn" v-else-if='item.Status=="待付款" && item.OrderType!=="家政套餐"' @click="toWxPay(item.OrderId)"> 付款 </div>

                    </div>
                </div>
                <p class="noContent" v-if="dataArr.length == 0">暂无相关信息</p>
             </van-tab>
         </van-tabs>
        
       </div>
       

    </div>
</template>

<script>
import { Toast } from 'vant'
import { Dialog } from 'vant'
export default {
    data () {
        return {
           tabArr: ['全部',"待预约","待服务","待付款","已完成","已取消"],
           showLoading: false,
           dataArr: [], // 列表数据
           tabStatus: '全部', // 类型
           page: 1, // 当前页
           hasNextPage: null, // 1有下一页 0没有下一页
        }
    },
    mounted(){

        window.addEventListener('scroll',this.getNextPage)  // 绑定滑动事件
    
        this.getList()
        
    },
    beforeDestroy () {
      window.removeEventListener('scroll',this.getNextPage)  // 移除滑动事件
    },
    methods: {
      back () {
          this.$router.back()
      },
      toHome () {
         this.$router.push('/')
      },
      getList(){
        Toast.loading({
          message: '加载中...'
        })
        this.$axios.get('/api/DjOrder/GetJzOrderList',{
            params: {
                 Page:1,  //页码
                 Rows:10,  //每页行数
                 Status:"",  //全部,待预约,待服务,待付款,已完成,已取消
            }
        }).then(res => {
            let data = res.data
            this.page = data.nextPage
            this.dataArr = data.rows
            this.hasNextPage = data.hasNextPage
            //console.log(data)
            Toast.clear()
        })
      },
      getNextPage () {
      
            let top = Math.abs(document.body.getBoundingClientRect().top) //滑动的top值
            let tabsHeight = this.$refs['tabs'].offsetHeight // tabs元素高度
            let phoneHeight = document.body.getBoundingClientRect().height // 手机高度
            if (top >= tabsHeight - phoneHeight) {   // 下拉到底部
            
              if (this.hasNextPage == 1) { // 有下一页
                    Toast.loading({
                        message: '加载中...'
                      })
                    this.$axios.get('/api/DjOrder/GetJzOrderList',{
                          params: {
                              Page:this.page,  //页码
                              Rows:10,  //每页行数
                              Status:this.Status,  //全部,待预约,待服务,待付款,已完成,已取消
                          }
                      }).then(res => {
                          
                          let data = res.data
                          this.page = data.nextPage
                          this.hasNextPage = data.hasNextPage
                          data.rows.forEach(i => {
                            this.dataArr.push(i)
                          })
                          //console.log(data)
                          Toast.clear()
                      })
              }
              

            }
        
        
      },
      changeTabs (index,title) {
          this.Status = title
          this.$axios.get('/api/DjOrder/GetJzOrderList',{
            params: {
                 Page:1,  //页码
                 Rows:10,  //每页行数
                 Status:title,  //全部,待预约,待服务,待付款,已完成,已取消
            }
        }).then(res => {
            let data = res.data
            this.page = data.nextPage
            this.dataArr = data.rows
            this.hasNextPage = data.hasNextPage
            console.log(data)
          
        })
        
      },
      toOrderDetail (id) {
         this.$router.push('/orderdetails?Id='+id)
      },
      toOfferWork (id) {
        this.$router.push('/pricelist?Id='+id)
      },
      toOfferResult (id) {
        this.$router.push('/assess?Id='+id)
      },
      toEditOrder (id,name) {
           if (name == "钟点保洁") {
						this.$router.push('/hoursorderedit?Id='+id)
					}else if (name == "定期保洁") {
            this.$router.push('/periodicorderedit?Id='+id)
          }else if (name == "空调清洗" || name == "洗衣机清洗" || name == "抽油烟机清洗" || name == "冰箱清洗" || name == "热水器清洗") {
            this.$router.push('/quantityorderedit?Id='+id)
          }else {
            this.$router.push('/areaorderedit?Id='+id)
          }
      },
      toCancel (id) {
         Dialog.confirm({
        title: '取消订单',
        message: '确定要取消该订单吗？'
        }).then(() => {
           //发送取消
           this.$axios.post('/api/DjOrder/CancelOrder',{
             Id:id
           }).then(res => {
             if(res.data.type == 1){
                Toast.success({message: '取消成功'})
                //this.$router.go(0)
                location.reload()
             }else{
                Toast.fail({message: '操作失败'})
             }
             
             
           })
       

        }).catch(() => {
        
        });
      },
      toWxPay (id) {
           window.location.href = '/wxpay/JzOrderPay.html?Id=' + id
      }
      
   }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.orderList
  width: 100%
  height: 100%
  .orderHeader
   position: fixed
   z-index: 100
   left: 0
   right: 0
   top: 0
   display: flex
   justify-content: space-between
   width: 100%
   height: 40px
   align-items: center
   background-color: green
   color: white
   font-weight: bold
   .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
    .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
     .iconshouye
        font-size: 20px
  .tabs
    width: 100%
    margin-top: 40px
    height: 100%   
    & .noContent
      text-align: center
      padding-top: 8px
      height: 500px
    & .orderOut
      width: 100%
      padding: 10px 6px
      box-sizing: border-box
      .orderTime
        font-size: 13px
        margin-bottom: 4px
        color: #999999
      .orderInner
        width: 100%
        border: 1px solid #ddd
        border-radius: 4px
        overflow: hidden
        background-color: white
        .innerHeader
          display: flex
          justify-content: space-between
          align-items: center
          border-bottom: 1px solid #ddd
          font-size: 13px
          padding: 6px 6px
          color: #999
          .order-status-tips
            background-color: #578EBE
            color: #fff
            height: 20px
            width: 56px
            margin-left: -6px
            font-size: 12px
            line-height: 20px
            text-align: center
        .innerContent
          padding: 8px
          border-bottom: 1px solid #ddd
          position: relative
          min-height: 60px
          &:last-child
            border-bottom: none
          &>p
            line-height: 24px
            font-size: 13px
          .info-tips
            position: absolute
            top: 0
            right: 0
            width: 64px
            padding: 4px
            color: #fff
            background-color: #009933
            text-align: center
            font-size: 12px
        .order-price
          padding: 8px
          border-bottom: 1px solid #ddd
          position: relative
          min-height: 60px
          &>p
            line-height: 24px
            font-size: 13px
          .info-tips
            position: absolute
            top: 0
            right: 0
            width: 64px
            padding: 4px
            color: #fff
            background-color: #009933
            text-align: center
            font-size: 12px
          .info-price-btn
            position: absolute
            right: 2px
            bottom: 8px
            border-radius: 2px
            min-width: 64px
            padding: 6px
            color: #fff
            background-color: #f7bb4b
            text-align: center

        .order-process-info
          padding: 8px
          border-bottom: 1px solid #ddd
          position: relative
          min-height: 60px
          &>p
            line-height: 24px
            font-size: 13px
          .info-tips
            position: absolute
            top: 0
            right: 0
            width: 64px
            padding: 4px
            color: #fff
            background-color: #009933
            text-align: center
            font-size: 12px
          .info-assess-btn
            position: absolute
            right: 2px
            bottom: 8px
            border-radius: 2px
            min-width: 64px
            padding: 6px
            color: #fff
            background-color: rgb(81, 202, 218)
            text-align: center    
            
        .innerButton
          display: flex
          width: 100%
          justify-content: center
          align-items: center
          height: 32px
          line-height: 32px
          font-size: 14px
          .order-cancal-btn
            width: 50%
            color: #fff
            background-color: rgb(185, 40, 40)
            text-align: center
          .order-baseinfo-modify-btn
            flex: 1
            width: 100%
            color: #fff
            background-color: #f7bb4b
            text-align: center

        .order-pay-btn
          width: 100%;
          text-align: center;
          background-color: rgb(185, 40, 40);
          color: #fff;
          height: 32px;
          line-height: 32px;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          box-shadow: 0 0 8px 0 rgba(232, 237, 250, .6), 0 2px 4px 0 rgba(232, 237, 250, .5);
		
          
            

</style>



// WEBPACK FOOTER //
// src/pages/OrderList/OrderList.vue